/* eslint-disable react/no-array-index-key */
import React from 'react'

import Breadcrumbs from 'components/Breadcrumbs'
import DocumentTile from 'components/Documents/DocumentTile'
import SkeletonBlock from 'components/Skeletons/SkeletonBlock'
import { useGetDocumentsQuery } from 'containers/contentful/rtkApi'

const Documents = ({ title, contentfulSlug }) => {
  const { data: items, isLoading } = useGetDocumentsQuery({ contentfulSlug })

  return (
    <div className="py-4 md:py-8 *:px-4 md:*:px-8">
      <Breadcrumbs />

      <h1 className="text-[22px] leading-[30px] font-semibold md:text-h1 md:leading-10 mt-12">
        {title}
      </h1>
      <div className="h-px w-full px-0 bg-grey-300 mt-4 mb-6" />
      <div className="grid auto-rows-fr gap-4 md:grid-cols-2 md:gap-6">
        {isLoading
          ? new Array(3)
              .fill(undefined)
              .map((_, index) => (
                <SkeletonBlock
                  className="w-full h-[160px] rounded-2xl"
                  key={index}
                  data-test-id="document-skeleton"
                />
              ))
          : items.map(item => (
              <DocumentTile
                key={item.id}
                isLoading={isLoading}
                title={item.title}
                currentDocumentUrl={item.currentFileUrl}
                previousVersionFileUrl={item.previousVersionFileUrl}
              />
            ))}
      </div>
    </div>
  )
}

export default Documents
